import { render, staticRenderFns } from "./consultationDetails.vue?vue&type=template&id=2778f3ce&scoped=true&"
import script from "./consultationDetails.vue?vue&type=script&lang=js&"
export * from "./consultationDetails.vue?vue&type=script&lang=js&"
import style0 from "./consultationDetails.vue?vue&type=style&index=0&id=2778f3ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2778f3ce",
  null
  
)

export default component.exports